import { Skeleton } from '@/components/ui/Skeleton';

const ROW_COUNT = 3;

/**
 * Placeholder shown while a folder loads, shaped like `ResourceList`: a 2:1
 * thumbnail beside (above, on mobile) a title, description and action line.
 */
export function ResourceListSkeleton() {
  return (
    <div className="flex flex-col gap-4" aria-hidden="true">
      {Array.from({ length: ROW_COUNT }).map((_, i) => (
        <div
          key={i}
          className="rounded-card shadow-card flex flex-col gap-4 bg-white p-4 sm:flex-row sm:items-start sm:gap-6"
        >
          <Skeleton className="aspect-[2/1] w-full shrink-0 rounded-xl sm:w-1/3" />
          <div className="flex min-w-0 flex-1 flex-col gap-3">
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-24" />
          </div>
        </div>
      ))}
    </div>
  );
}
